type AdvisorSearchOptions = {
  search?: string
  zip?: string
}

declare global {
  interface Window {
    AMERIPRISE_ADVISORS_SITE_URL: string
  }
}

export function buildAdvisorSearchUrl(
  options: AdvisorSearchOptions = {}
): string {
  const { search, zip } = options
  const criteria = {
    al: 0,
    aof: '',
    d: '',
    li: false,
    nrr: 10,
    rd: 0,
    se: '',
    sri: 0,
    st: zip ? 'zip code' : 'city, state',
    t: search || zip
  }

  const crit =
    '{' +
    Object.keys(criteria)
      .map(key => `${key}:${criteria[key as keyof typeof criteria]}`)
      .join(';') +
    '}'

  const params = [
    `crit=${encodeURIComponent(crit)}`,
    'old=true',
    'page=0',
    'view=list'
  ].join('&')

  return `${window.AMERIPRISE_ADVISORS_SITE_URL}/#search?${params}`
}
